export enum CARE_TEAM_TYPE {
  SELECTED = 'selected',
  DISMISSED = 'dismissed'
}
